import React, { Component } from "react";
import styled from "styled-components";

const Container = styled.div`
  background: #ffffff;
  border-radius: 5px;
  position: relative;
  padding: 15px 20px;
  width: calc(${props => props.width || "50%"} - 25px);
  margin: ${props => (props.mr ? "0 25px 25px 0" : "0 0 25px 0")};
  box-shadow: ${props =>
    props.active
      ? "0 0 13px 0 " + props.color
      : "0 2px 12px 0 rgba(218,218,218,0.50)"};
  float: left;
  cursor: pointer;
`;

const Stat = styled.h4`
  font-family: "Open Sans", sans-serif;
  font-size: 20px !important;
  font-weight: 500 !important;
  color: ${props => (props.active ? "#ffffff" : "#696969")};
  margin-bottom: 0;
  position: relative;
  z-index: 1;
  letter-spacing: 0.06px;
`;

const Title = styled.h5`
  font-family: "Open Sans", sans-serif;
  font-size: 12px !important;
  letter-spacing: 0.94px;
  margin-bottom: 0;
  position: relative;
  z-index: 1;
  color: ${props => (props.active ? "#ffffff" : "#696969")};
`;

export default class StatBox extends Component {
  render() {
    return (
      <Container
        mr={this.props.mr}
        color={this.props.color}
        active={this.props.active}
      >
        <Stat active={this.props.active}>{this.props.stat}</Stat>
        <Title active={this.props.active}>{this.props.title}</Title>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StatBox.js